import {useHasTariffLimit} from 'entities/user';

import {IncidentTab} from '../lib/incidentTabs';

export const useIncidentTabsAccess = (): Record<IncidentTab, boolean> => ({
    site: useHasTariffLimit('monitor_max_count_limit'),
    server: useHasTariffLimit('server_max_count_limit'),
    port: useHasTariffLimit('port_monitor_max_count_limit'),
    domain: useHasTariffLimit('domain_monitor_max_count_limit'),
});

export default useIncidentTabsAccess;
